import { LinkButton } from '@/components/ui';
import { BarbellGlyph } from '@/components/Logo';
import { ArrowRightIcon, GridIcon } from '@/lib/icons';

/**
 * The CRM close: the orange band. Charcoal type on orange, never white
 * (brand book §3.3). The contact path for large customers is stated as text and
 * as the mailto target.
 */
export function CrmCta() {
  return (
    <section id="crm-cta" className="relative overflow-hidden bg-accent text-brand-charcoal">
      <div aria-hidden="true" className="l2f-noise pointer-events-none absolute inset-0 opacity-30" />
      <div className="relative mx-auto flex max-w-[1200px] 2xl:max-w-[1440px] min-[1920px]:max-w-[1720px] flex-col items-start gap-8 px-4 py-16 sm:px-6 lg:flex-row lg:items-center lg:justify-between">
        <div className="flex items-center gap-6">
          <BarbellGlyph className="hidden h-12 w-auto shrink-0 text-brand-charcoal sm:block" />
          <div className="flex flex-col gap-3">
            <h2 className="max-w-[26ch] font-display text-[32px] font-black uppercase leading-[1.02] tracking-[-0.03em] sm:text-[44px]">
              Bring your roster onto one platform.
            </h2>
            <p className="max-w-[56ch] text-[15px] font-medium leading-relaxed">
              Start with a coaching plan, or talk to us about a gym or recovery centre with a hundred or more. AI
              assistance is included in every paid tier. For large customers, write to{' '}
              <span className="font-bold">info@lift2fit.com</span>.
            </p>
          </div>
        </div>

        <div className="flex w-full flex-col gap-3 sm:w-auto">
          <LinkButton
            href="#/crm/signup"
            size="lg"
            data-testid="crm-cta-start-coaching"
            className="l2f-cta-primary border-2"
          >
            Start coaching <ArrowRightIcon className="text-sm" />
          </LinkButton>
          <LinkButton
            href="mailto:info@lift2fit.com"
            size="lg"
            variant="outline"
            data-testid="crm-cta-talk"
            className="border-brand-charcoal/40 text-brand-charcoal hover:border-brand-charcoal hover:text-brand-charcoal"
          >
            Talk to us — info@lift2fit.com
          </LinkButton>
          <LinkButton
            href="#crm-pricing"
            size="lg"
            variant="outline"
            className="border-brand-charcoal/40 text-brand-charcoal hover:border-brand-charcoal hover:text-brand-charcoal"
          >
            <GridIcon className="text-base" /> See the tiers
          </LinkButton>
          <p className="text-[11px] font-bold uppercase tracking-[0.08em] text-brand-charcoal/70">
            Web only · a desk tool for coaches and gyms
          </p>
        </div>
      </div>
    </section>
  );
}
